import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useMST7020_R01Store } from "./Store_MST7020_R01";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { useState } from "react";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";

interface Props {
}

export const SearchSection_MST7020_R01 = ({
}: Props) => {
  const { MST7020_R01Filter, setMST7020_R01Filter } = useMST7020_R01Store();

  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPos, setPickerPos] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
    <SearchSectionForm>
		{/* MST7020_R01Filter : {JSON.stringify(MST7020_R01Filter)} <br/> */}
		<SearchDateRangeForm
				label="조회 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={MST7020_R01Filter.dateRange}		setDateRange={(dateRange) => setMST7020_R01Filter({ dateRange })}
				pickerPosition={pickerPos}
				setPickerPosition={setPickerPos}
			/>
      
    </SearchSectionForm>
  );
}; 